import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGhost, FaHome } from 'react-icons/fa';

const Pnf = ({ admin }) => {
  const navigate = useNavigate();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
    background: '#f9f9f9',
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
  };

  const headingStyle = {
    fontSize: '6rem',
    color: '#ff6b6b',
    marginBottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const subHeadingStyle = {
    fontSize: '2rem',
    marginBottom: '1rem',
  };

  const paragraphStyle = {
    fontSize: '1.1rem',
    marginBottom: '2rem',
    color: '#555',
    maxWidth: '400px',
  };

  const buttonStyle = {
    padding: '0.8rem 1.5rem',
    backgroundColor: '#ff6b6b',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    transition: 'background 0.3s',
  };

  const iconStyle = {
    marginRight: '0.5rem',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>
        <FaGhost style={{ marginRight: '10px' }} />
        404
      </h1>
      <h2 style={subHeadingStyle}>Oops! Page Not Found</h2>
      <p style={paragraphStyle}>
        The page you are looking for doesn’t exist or has been moved. Maybe try going back home?
      </p>
      <button
        style={buttonStyle}
        onClick={() => admin ? navigate('/admin/dashboard') : navigate('/')}
        onMouseEnter={e => e.target.style.backgroundColor = '#ff4757'}
        onMouseLeave={e => e.target.style.backgroundColor = '#ff6b6b'}
      >
        <FaHome style={iconStyle} />
        {admin ? 'Go to Dashboard' : 'Go Home'}
      </button>
    </div>
  );
};

export default Pnf;
